import { getMissions } from '@/lib/api';
import { useEffect, useState } from 'react';
import { Challenge } from '../types/index';

export function useMissions(): { missions: Challenge[]; isLoading: boolean } {
  const [missions, setMissions] = useState<Challenge[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMissions = async () => {
      try {
        const { missions } = await getMissions();
        setMissions(missions || []);
      } catch (error) {
        console.error('Failed to fetch missions:', error);
        setMissions([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMissions();
  }, []);

  return {
    missions,
    isLoading,
  };
}
